export default {
  getMessage: field => 'The ' + field + ' must be named ' + field + '.png',
  validate: (value, fileName) => {
    // value is passed automatically from input, filename we pass manually
    return value.length ? value[0].name === fileName[0] : true
  }
}
